// extracted by css-extract-rspack-plugin
export default {"btn":"erp-btn_X7TGV","btnPrimary":"erp-btnPrimary_l_1cG"};